import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {connect} from 'react-redux';
import {Link, browserHistory} from 'react-router';
import {List, Set} from 'immutable';
import NavLink from 'components/NavLink';
import Spinner from 'components/Spinner';
import {SIZE_LARGE} from 'components/Spinner';
import Header from '../components/Header';
import AddIcons from '../components/AddIcons';
import UpgradeModal from '../components/UpgradeModal';
import {MAX_ICONS_PER_KIT} from '../components/UpgradeModal';
import {Request, RequestsMixin, GET} from 'requests';
import {ResourcesMatching, Requesting, Done} from 'requests/components';

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;

  const ic = ownProps.location.query.ic;
  const activeFacetIds = Set((ic) ? ic.split(',') : [])
    .map((iconSetId) => parseInt(iconSetId, 10));

  return {
    kitToken,
    requests: state.requests,
    query: (ownProps.location.query.q || ''), // eslint-disable-line id-length
    activeFacetIds,
    searchResults: state.kitIconSetSearch.get('results'),
  };
};

const AddIconsController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    requests: PropTypes.object.isRequired,
    query: PropTypes.string,
    searchResults: PropTypes.object,
    activeFacetIds: ImmutablePropTypes.set,
  },

  contextTypes: {
    iconsSearchIndexName: PropTypes.string,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getDefaultProps() {
    return {
      query: '',
      searchResults: null,
      subscription: null,
      iconSets: List(),
      iconSetIdsInSubscription: Set(),
      workingSetIcons: List(),
    };
  },

  getInitialState() {
    return {
      triedToRequestDataAgain: false,
      showUpgradeModal: false,
      upgradeModalReason: null,
      shouldRequestWorkingSetIcons: false,
    };
  },

  componentWillMount() {
    this.requestData();
  },

  requestData() {
    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
      }),
    });

    this.setRequest({
      workingSetIcons: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
      }),
    });

    this.setRequest({
      subscription: new Request({
        method: GET,
        url: ['api', 'subscriptions'],
      }),
    });

    this.setRequest({
      iconSets: new Request({
        method: GET,
        url: ['api', 'icon-sets'],
      }),
    });
  },

  canAddIconsToKit() {
    const requests = [this.requests.kit, this.requests.workingSetIcons];
    let retval = false;

    if (this.resourceManager().requests.allDone(requests)) {
      const {
        workingSetIcons,
        subscription,
      } = this.resources();

      retval = workingSetIcons.size < subscription.iconsPerKitAllowed;
    }

    return retval;
  },

  handleExceededIconsInKit() {
    this.setState({
      showUpgradeModal: true,
      upgradeModalReason: MAX_ICONS_PER_KIT,
    });
  },

  handleRequestToUpgrade() {
    location.assign('/upgrade');
  },

  handleHideUpgradeModal() {
    this.setState({
      showUpgradeModal: false,
    });
  },

  handleTryLoadingDataAgain() {
    this.clearRequests();
    this.requestData();

    this.setState({triedToRequestDataAgain: true});
  },

  resources() {
    const rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').get(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
      workingSetIcons: rm.type(this.requests.workingSetIcons, 'working-set-icons').all(),
      icons: rm.type(this.requests.iconSets, 'icons').all(),
      iconSets: rm.type(this.requests.iconSets, 'icon-sets').all(),
    };
  },

  renderIcons() {
    const {
      kitToken,
      query,
      activeFacetIds,
    } = this.props;
    const {
      subscription,
      workingSetIcons,
      iconSets,
      icons,
    } = this.resources();
    const {
      iconsSearchIndexName: index,
    } = this.context;
    const donePath = `/kits/${kitToken}/icons`;

    return (
      <div>
        <UpgradeModal
          isOpen={this.state.showUpgradeModal}
          reason={this.state.upgradeModalReason}
          subscription={subscription}
          onOkayClicked={this.handleHideUpgradeModal}
          onUpgradeClicked={this.handleRequestToUpgrade}
          onCloseClicked={this.handleHideUpgradeModal}
        />

        <AddIcons
          key="add-icons"
          dispatch={this.props.dispatch}
          requests={this.props.requests}
          onExceededIconsInKit={this.handleExceededIconsInKit}
          index={index}
          kitToken={kitToken}
          donePath={donePath}
          query={query}
          subscription={subscription}
          activeFacetIds={activeFacetIds}
          canAddIconsToKit={this.canAddIconsToKit()}
          searchResults={this.props.searchResults}
          iconSets={iconSets.sortBy((iconSet) => iconSet.name)}
          icons={icons}
          iconSetIdsInSubscription={subscription.iconSets}
          workingSetIcons={workingSetIcons}
        />
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="well bg-white will-fill-page p-xs-a-lg is-loading">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  renderFailed() {
    return (
      <div className="well bg-white will-fill-page p-xs-a-lg">
        <div className="icon-loading-failed">
          <a disabled={this.state.triedToRequestDataAgain} onClick={this.handleTryLoadingDataAgain} className="btn btn-muted pull-right m-xs-t-md m-xs-l-lg">Try again</a>
          <p><i className="ficon ficon-oi"></i>Oi. Some of the data failed to load. This can happen sometimes because the Internet is an unreliable creature.</p>
        </div>
      </div>
    );
  },

  renderMain() {
    const {
      kit,
    } = this.resources();
    const {
      kitToken,
    } = this.props;

    return (
      <div className="well bg-white will-fill-page p-xs-a-lg">
        <Link to={`/kits/${kitToken}/icons`} className="link-dashed-none">&lsaquo; Back to {kit.name}</Link>
        <Header heading={'Add Icons'} donePath={`/kits/${kitToken}/icons`}>
          <NavLink to={`/kits/${kitToken}/icons/new`}>All Icons</NavLink>
          <NavLink to={`/kits/${kitToken}/icons/upload`}>Upload an Icon</NavLink>
        </Header>
        {this.renderIcons()}
      </div>
    );
  },

  render() {
    const {
      kit: kitRequest,
      iconSets: iconSetsRequest,
      workingSetIcons: workingSetIconsRequest,
      subscription: subscriptionRequest,
    } = this.requests;

    const requests = [kitRequest, iconSetsRequest, workingSetIconsRequest, subscriptionRequest];

    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={requests} render={this.renderSpinner} failure={this.renderFailed} />
        <Done all={requests} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(AddIconsController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/AddIconsController.js